
<!-- Optional per-tab header above the count (e.g. Text Annotations' "Download annotations"). -->
<ng-content select="[sidebarHeader]" />

<div class="filter-btns-container">
  @if (tabName() === 'Domains') {
    {{ uniqueTedDomains().length + ' TED ' + (uniqueTedDomains().length === 1 ? 'Domain' : 'Domains') }}
  } @else {
    {{ uniqueTedDomains().length + ' distinct protein' }}
  }
</div>

<section [ngClass]="{ 'scrollable-body': tedDomainData().length > 10, 'non-scrollable-body': tedDomainData().length <= 10 }">
  @for(ted of uniqueTedDomains(); track ted; let i = $index;) {
    <div class="card domain-card" (click)="onCardClick(ted)" [class.selected-card]="selectedRowCard()?.tedNumber === ted.tedNumber">
      @if (tabName() === 'Domains') {
        <p class="card-title">
          <span style="display: block"><strong>Domain {{ ted.tedNumber }}</strong></span>
        </p>
      }
      @if (tabName() === 'Macromolecules' || tabName() === 'TextAnnotations') {
        <p class="card-title">
          <span style="display: block"><strong>{{ ted.displayTitle || ted.uniprotDescription || ('Macromolecule ' + ted.tedNumber) }}</strong></span>
        </p>
      }
      @if (tabName() === 'Domains' && ted.label !== '-') {
        <p  class="card-chain">CATH:
          {{ ted.label }}
        </p>
      }
      @if (tabName() === 'Domains' && ted.label === '-') {
        <p  class="card-chain">CATH:
          No match
        </p>
      }
      @if (tabName() === 'Macromolecules' || tabName() === 'TextAnnotations') {
        <p class="card-chain">
          {{ ted.displayChains || 'Chain data unavailable' }}
        </p>
      }
      @if (tabName() === 'TextAnnotations' && ted.annotationCount !== null) {
        <p class="card-chain">
          {{ ted.annotationCount }} {{ ted.annotationCount === 1 ? 'annotation' : 'annotations' }}
        </p>
      }
    </div>
  }
</section>
